function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getDetail, getLogDetail } from '@/api/thirdOrderApi.js';
import transformState from '@/utils/transformState.js';
import { orderStateOption } from '../static';
import * as pintuanApi from '@/api/pintuanApi';
export default {
  name: 'thirdOrderDetail',
  components: {},
  props: {
    orderId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      orderStateOption: orderStateOption,
      dialogVisible: false,
      orderDatalist: {},
      id: null,
      logLists: [],
      // 日志列表
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      constants: this.$constants,
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      formData: {},
      timeVal: [],
      listDataNew: {}
    };
  },
  mounted: function mounted() {},
  methods: {
    transformState: transformState,
    openDetail: function openDetail(id) {
      this.id = id;
      if (!id) {
        this.$message.warning('未查询到该订单！');
        return;
      }
      this.handleTimer();
      this.getOrderData();
    },
    getOrderData: function getOrderData() {
      var _this = this;
      getDetail(this.id).then(function (res) {
        _this.formData = res;
      });
      this.dialogVisible = true;
      this.handleSrsht();
    },
    handleSrsht: function handleSrsht() {
      var _this2 = this;
      getLogDetail(_objectSpread(_objectSpread({
        pinkId: this.id
      }, this.listPram), {}, {
        dateLimit: this.timeVal.join(',')
      })).then(function (res) {
        _this2.listDataNew = res;
        _this2.listLoading = false;
      });
    },
    handleTimer: function handleTimer() {
      // 获取当前日期
      var today = new Date();
      var startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - 7);

      // 格式化日期为 yyyy-MM-dd
      var formatDate = function formatDate(date) {
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1).padStart(2, '0');
        var day = String(date.getDate()).padStart(2, '0');
        return "".concat(year, "-").concat(month, "-").concat(day);
      };
      var startDate = formatDate(startOfWeek);
      var endDate = formatDate(today);
      this.timeVal = [startDate, endDate];
    },
    onchangeTime: function onchangeTime(value) {
      this.timeVal = value;
      this.handleSrsht();
    },
    // 关闭弹窗，判断是否需要刷新列表
    handleColse: function handleColse() {
      this.dialogVisible = false;
    },
    // 列表分页查询
    handlerGetListData: function handlerGetListData() {
      var _this3 = this;
      this.listLoading = true;
      getLogDetail(_objectSpread(_objectSpread({
        pinkId: this.id
      }, this.listPram), {}, {
        dateLimit: this.timeVal.join(',')
      })).then(function (res) {
        console.log(res, '21111');
        _this3.listDataNew = res;
      });
      this.listLoading = false;
    },
    // 翻页
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    // 翻页
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    }
  }
};